import React from "react";
import styled from "styled-components";
import { theme } from "../styles/theme";
import ContactForm from "../components/ContactForm";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const ContactSection = styled.section`
  padding: 5rem 0;
  background-color: ${theme.colors.light};
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;

  .container {
    width: 100%;
  }

  .contact-header {
    text-align: center;
    margin-bottom: 3rem;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
      color: ${theme.colors.primary};

      @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 2rem;
      }
    }

    p {
      font-size: 1.1rem;
      max-width: 700px;
      margin: 0 auto;
      color: ${theme.colors.gray};
    }
  }

  .contact-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;

    .info-card {
      background-color: ${theme.colors.white};
      border-radius: 10px;
      padding: 1.5rem;
      text-align: center;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      }

      .icon {
        width: 50px;
        height: 50px;
        background: linear-gradient(
          135deg,
          ${theme.colors.primary},
          ${theme.colors.secondary}
        );
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 1rem;
        color: ${theme.colors.white};
        
        svg {
          font-size: 1.5rem;
        }
      }

      h3 {
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
        color: ${theme.colors.primary};
      }

      p {
        color: ${theme.colors.gray};
        margin: 0;
      }
    }
  }
`;

const ContactPage = () => {
  return (
    <ContactSection>
      <div className="container">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>
            Have questions about our products or services? We'd love to hear
            from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div className="contact-info">
          <div className="info-card">
            <div className="icon">
              <LocationOnIcon />
            </div>
            <h3>Address</h3>
            <p> 6056 Sibweni Road, Northmead, Lusaka</p>
          </div>

          <div className="info-card">
            <div className="icon">
              <PhoneIcon />
            </div>
            <h3>Phone</h3>
            <p>+260 (211) 354-419</p>
          </div>

          <div className="info-card">
            <div className="icon">
              <EmailIcon />
            </div>
            <h3>Email</h3>
            <p>support@amplelark.com</p>
          </div>
        </div>

        <ContactForm />
      </div>
    </ContactSection>
  );
};

export default ContactPage;